<template>
    <span class="relative flex h-2 w-2">
        <span
            class="absolute inline-flex h-full w-full animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite] rounded-full bg-indigo-500 opacity-75"
        ></span>
        <span
            class="relative inline-flex h-2 w-2 rounded-full bg-indigo-600"
        ></span>
    </span>
</template>

<script setup lang="ts"></script>
